import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Component_MAWP } from "../../services/component_mawp";
import { Laminations_module } from "../../services/laminations_module";
import { saveAs } from 'file-saver';
import { FormControlsEventProxyService } from "../../services/formcontrols_eventproxy_service";
import { LTA_module } from "../../services/lta_module";
import { Dent_Module } from "../../services/dent_module";
import { MatDialog } from "@angular/material/dialog";
import { WarningModalComponent } from "../warning-modal/warning-modal.component";
import { GML_module } from "../../services/gml_module";
import { LTAP_module } from "../../services/ltap_module";
import { Pitting_module } from "../../services/pitting_module";
import { GougeModule } from "../../services/gouge_module";
import { BlisterHIC_module } from "../../services/blisterHIC_module";
import { Crack_Module } from "../../services/crack_module";
import { ComponentEventService } from "../../services/component_event.service";
import { Component_MAEP } from "../../services/component_maep";
import { Component_MFH } from "../../services/component_mfh";
// import * as fs from 'fs';
// import { json } from "stream/consumers";

@Component({
    selector: "import-export",
    templateUrl: "import-export.component.html",
    styleUrls: ["import-export.component.css"],
    standalone: false
})
export class ImportExportComponent {
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(private formControlsEventProxyService: FormControlsEventProxyService,
    private componentEventService: ComponentEventService,
    
    private dialog: MatDialog) { }
  public isLoading: boolean = false;

  triggerGMLDataUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerGMLDataUpdateFormControlsEvent();
  }

  //-shameer
  triggerGMLtypeAFormControlsEvent1() {
    this.formControlsEventProxyService.triggerGMLtypeAFormControlsEvent();
  }
  //shmaeer

   //-shameer
   triggerGMLtypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerGMLtypeAupdateradioFormControlsEvent();
  }

  triggerLTAtypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerltatypeAupdateradioFormControlsEvent();
  }

  triggerLTAPtypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerltaptypeAupdateradioFormControlsEvent();
  }

  triggergougestypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggergougestypeAupdateradioFormControlsEvent();
  }

  triggerpittingtypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerpittingtypeAupdateradioFormControlsEvent();
  }

  triggerblisterhictypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerblisterhictypeAupdateradioFormControlsEvent();
  }

  triggercrackliketypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggercrackliketypeAupdateradioFormControlsEvent();
  }
  

  triggerdenttypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerdenttypeAupdateradioFormControlsEvent();
  }

  triggerdentgougetypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerdentgougetypeAupdateradioFormControlsEvent();
  }

  triggerlaminationstypeAupdateradioFormControlsEvent1() {
    this.formControlsEventProxyService.triggerlaminationstypeAupdateradioFormControlsEvent();
  }
  //shmaeer

  triggerInspectionDataUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerInspectionDataEvent();
  }

  triggerMAWPUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerMAWPEvent();
  }
  triggerMAEPUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerMAEPEvent();
  }

  triggerLaminationsApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerLaminationsApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerLTA_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerLTA_ApplicabilityCheckboxFormControlUpdateEvent();
  }


  triggerLTA_TYPEApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerltatypeAFormControlsEvent();
  }

  triggerLTAP_TYPEApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerltaptypeAFormControlsEvent();
  }

  triggerLTAP_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerLTAP_ApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerDents_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerDents_ApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerPitting_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerPitting_ApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerPittingInformationUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerPittingInformationEvent();
  }

triggerGouges_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerGougestypea_ApplicabilityCheckboxFormControlUpdateEvent();
}

triggerPitting_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerPittingtypea_ApplicabilityCheckboxFormControlUpdateEvent();
}


triggerBlisterHIC_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerBlisterHICtypea_ApplicabilityCheckboxFormControlUpdateEvent();
}


triggerCracklike_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggercrackliketypea_ApplicabilityCheckboxFormControlUpdateEvent();
}


triggerDent_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerDenttypea_ApplicabilityCheckboxFormControlUpdateEvent();
}


triggerDentGouge_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerDentGougetypea_ApplicabilityCheckboxFormControlUpdateEvent();
}

///
triggerLaminations_TYPEAApplicabilityCheckboxFormControlUpdateEvent() {
  this.formControlsEventProxyService.triggerLaminationstypea_ApplicabilityCheckboxFormControlUpdateEvent();
}

///

  triggerGouges_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerGouges_ApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerGougesDataUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerGougesDataEvent();
  }

  triggerDentGouge_ApplicabilityCheckboxFormControlUpdateEvent() {
    this.formControlsEventProxyService.triggerDentGouge_ApplicabilityCheckboxFormControlUpdateEvent();
  }

  triggerDentGouge_ComponentInformationUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerDentGouge_ComponentInformationEvent();
  }

  triggerBlisterAndHIC_ApplicabilityCheckboxAndFormUpdateEvent() {
    this.formControlsEventProxyService.triggerBlisterAndHIC_ApplicabilityCheckboxAndFormUpdateEvent();
  }

  triggerCrackLikeIndications_ApplicabilityCheckboxAndFormUpdateEvent() {
    this.formControlsEventProxyService.triggerCrackLikeIndications_ApplicabilityCheckboxAndFormUpdateEvent();
  }

  triggerCrackLikeIndicationse_ComponentInformationUpdateFormControlsEvent() {
    this.formControlsEventProxyService.triggerCrackLikeIndications_ComponentInformationEvent();
  }

  exportToJson() {
    let jsonData: string;
    const strD_iclass =
    (typeof Component_MAWP?.strD_iclass !== 'undefined' && Component_MAWP?.strD_iclass !== null)
      ? Component_MAWP.strD_iclass
      : Component_MAEP.strD_iclass;

    // LML MFH path: Component_MFH.intEquip===8 marks a tank MFH assessment
    const isMfhLml = Component_MFH.intEquip === 8 && (strD_iclass === 1 || strD_iclass === 3);

    switch (strD_iclass) {
      case 0: // GML
        jsonData = GML_module.ExportToJson(this.componentEventService.radioButtonDI);
        break;
      case 1: // LML – MFH path takes priority
        jsonData = isMfhLml
          ? Component_MFH.ExportToJson(this.componentEventService.radioButtonDI)
          : LTA_module.ExportToJson(this.componentEventService.radioButtonDI);
        break;
      case 2: // LMLPD
        jsonData = LTAP_module.ExportToJson(this.componentEventService.radioButtonDI);
        break;
      case 3: // Gouges – MFH path takes priority
        jsonData = isMfhLml
          ? Component_MFH.ExportToJson(this.componentEventService.radioButtonDI)
          : GougeModule.ExportToJson(this.componentEventService.radioButtonDI);
        break;
      case 4: // Pitting
        jsonData = Pitting_module.ExportToJson();
        break;
      case 5: // Blister and HIC
        jsonData = BlisterHIC_module.ExportToJson();
        break;
      case 6: // Crack-Like Indications
        jsonData = Crack_Module.ExportToJson();
        break;
      case 7: // Dent
        jsonData = Dent_Module.DentExportToJson();
        break;
      case 8: // DentGouge
        jsonData = Dent_Module.DentGougeExportToJson();
        break;
      case 9: // Laminations
        jsonData = Laminations_module.ExportToJson();
        break;
      default:
        break;
    }

   const jsonBlob = new Blob([jsonData], { type: 'application/json' });
    let date = new Date();
    let formattedDate = (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getFullYear();
    //shameer -start
    let typeatext:string;
    const typeASelection = parseInt(localStorage.getItem("TypeAradioselection"));
    const damageClass = Number(strD_iclass);
    const isMfhAssessment = typeASelection === 7 ||
      Number((JSON.parse(jsonData || "{}")?.Component_MFH?.intEquip ?? -1)) === 8;
    // Tank (API 650 AST) files follow the Domain_AST_Date convention, keyed by damage class
    const tankDomainByClass: Record<number, string> = { 0: "GML", 1: "LML", 2: "LMLPD" };
    if(parseInt(localStorage.getItem("TypeAradioselection")) == 1)
    {
      typeatext = "Vert_Vess";
    }
    else if(parseInt(localStorage.getItem("TypeAradioselection")) == 2)
    {
      typeatext = "Hor_Vess";
    }
    else if(parseInt(localStorage.getItem("TypeAradioselection")) == 3)
    {
      typeatext = "CS_LAS_Pip";
    }
    else if(parseInt(localStorage.getItem("TypeAradioselection")) == 4)
    {
      typeatext = "Hi_Alloy_Pip";
    }
    else if(parseInt(localStorage.getItem("TypeAradioselection")) == 5)
    {
      typeatext = "Sph_For_Heads";
    }
    else if(parseInt(localStorage.getItem("TypeAradioselection")) == 7)
    {
      typeatext = "MFH";
    }
    if (!typeatext || typeatext.trim() === "") {
      typeatext = isMfhAssessment ? "MFH" : "TypeA";
    }
    //shameer -end
    let fileName: string;
    const baseClass = Component_MAWP.strD_class || Component_MAEP.strD_class || "GML";
    const defaultName = isMfhAssessment
      ? `${tankDomainByClass[damageClass] ?? "GML"}_AST_${formattedDate}.json`
      : `${baseClass}_${typeatext}_${formattedDate}.json`;

    if(this.componentEventService.radioButtonDI == 'radioButton1_DI_enabled'){
     fileName = prompt('Please enter a file name:', defaultName);
    }
    else if(this.componentEventService.radioButtonDI == 'radioButton2_DI_enabled'){
    fileName = prompt('Please enter a file name:', isMfhAssessment ? defaultName : (Component_MAEP.strD_class + "_" + typeatext + "_EP_" + formattedDate + '.json'));
    }
    else {
      fileName = prompt('Please enter a file name:', defaultName);
    }
    if (fileName !== null) {
      const finalFileName = fileName.trim() === "" ? defaultName : fileName;
      saveAs(jsonBlob, finalFileName);
    }
  }

  openFileDialog() {
    this.isLoading = true;
    const fileInput = this.fileInput.nativeElement;
    fileInput.click();
  }

 private handleGMLImport(jsonDataResult: any) {
  GML_module.ImportFromJson(jsonDataResult);
  // Map TypeA radio selection to value
  const typeAOptions: Record<string, number> = {
    "VerticalVessel": 1,
    "HorizonalVessel": 2,
    "CarbonandLowAllySteelPiping": 3,
    "HighAlloyNonFerrousSteelPiping": 4,
    "SphericalComponents": 5,
    "CylindricalAtmosphericStorageTankShellCourses": 7
  };
  const typeASelect = (
    jsonDataResult?.typeaData?.TypeARadioSelect ??
    jsonDataResult?.GML_module?.typeAradsel
  )?.toString();
  const isTankFromJson =
    Number(jsonDataResult?.Component_MFH?.intEquip) === 8 ||
    jsonDataResult?.typeaData?.ComponetType?.toString().toUpperCase() === "TANK" ||
    jsonDataResult?.GML_module?.Cmptype?.toString().toUpperCase() === "TANK" ||
    jsonDataResult?.GML_module?.typeAradsel?.toString() === "CylindricalAtmosphericStorageTankShellCourses";
  const radval = typeAOptions[typeASelect] || (isTankFromJson ? 7 : 1);
  this.componentEventService.updateTypeASelectedValue(radval);
  this.componentEventService.updatetypeAradioselected(radval);
  localStorage.setItem("TypeAradioselection", radval.toString());

  if (radval === 7 || isTankFromJson) {
    Component_MFH.intEquip = 8;
    Component_MAWP.strD_class = "GML";
    Component_MAWP.strD_iclass = 0;
    Component_MAEP.strD_class = "GML";
    Component_MAEP.strD_iclass = 0;
  }

  // Damage radio button
  const persistedDamageValue = (
    jsonDataResult?.GML_module?.typedamageval ?? jsonDataResult?.typedamageval
  )?.toString().toUpperCase();
  const importedLoadingType = Number(jsonDataResult?.GML_module?.intLoadingType);
  const damageVal = isTankFromJson
    ? "RADIOBUTTON1_DI_ENABLED"
    : persistedDamageValue ||
      (importedLoadingType === 0
        ? "RADIOBUTTON1_DI_ENABLED"
        : importedLoadingType === 1
          ? "RADIOBUTTON2_DI_ENABLED"
          : jsonDataResult?.Component_MAWP && !jsonDataResult?.Component_MAEP
            ? "RADIOBUTTON1_DI_ENABLED"
            : jsonDataResult?.Component_MAEP && !jsonDataResult?.Component_MAWP
              ? "RADIOBUTTON2_DI_ENABLED"
              : "");
  let damageKey = "";
  if (damageVal === "RADIOBUTTON1_DI_ENABLED".toUpperCase()) 
  {
      damageKey = "radioButton1_DI_enabled";
       GML_module.intLoadingType = 0; // Internal Pressure
        // Store radio button value in both components
        Component_MAWP.strRadio = 0;
         Component_MAEP.strRadio = 0;
        this.componentEventService.radioButtonDI = "radioButton1_DI_enabled";
  }
  else if (damageVal === "RADIOBUTTON2_DI_ENABLED".toUpperCase()) 
    {
       damageKey = "radioButton2_DI_enabled";
       GML_module.intLoadingType = 1; // External   Pressure
        // Store radio button value in both components
         Component_MAWP.strRadio = 1;
         Component_MAEP.strRadio = 1;
        this.componentEventService.radioButtonDI = "radioButton2_DI_enabled";

    }
  // Level of Assessment visibility reads this flag when the load type is applied.
  const importedTypeAResult = jsonDataResult?.typeaData?.typeAresult?.toString().toUpperCase();
  if (importedTypeAResult === "PASS" || isTankFromJson) {
    localStorage.setItem("TypeAPassorFail", "1");
  } else if (importedTypeAResult === "FAIL") {
    localStorage.setItem("TypeAPassorFail", "0");
  }
  this.componentEventService.updateTypeDamageValue(damageKey);
  this.componentEventService.isImporting = true;
  // Tooltip and unit
  const inpt1 = jsonDataResult.typeaData.Input1_value;
  const inpt2 = jsonDataResult.typeaData.Input2_value;
  localStorage.setItem('verticalinputs', JSON.stringify({ inputvalue1: inpt1, inputvalue2: inpt2 }));

  const TypeofUnit = jsonDataResult.typeaData.TypeofUnit?.toString();
  const us_si = TypeofUnit === "US" ? 0 : 1;
  this.componentEventService.updatetypeAinput1val(inpt1);
  this.componentEventService.updatetypeAinput2val(inpt2);
  this.componentEventService.updatetypeAUnitTypeval(us_si);

  this.triggerGMLtypeAupdateradioFormControlsEvent1();

  // TypeA result
  let typaresfmjsn = 0;
  if (jsonDataResult.typeaData.typeAresult?.toString() === "PASS") {
    this.triggerGMLDataUpdateFormControlsEvent();
    typaresfmjsn = 0;
  } else if (jsonDataResult.typeaData.typeAresult?.toString() === "FAIL") {
    this.triggerGMLtypeAFormControlsEvent1();
    typaresfmjsn = 1;
  }
  this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);
}

importFromJson(files: FileList) {
  const file = files.item(0);
  const reader = new FileReader();
  reader.onload = () => {
    const jsonData = reader.result.toString();
    const jsonDataResult = JSON.parse(jsonData);

    if (!this.importedDataWithErrors(jsonDataResult)) {
    // Validate that the current assessment module matches the saved file's module
    const savedD_iclass = this.getDamageClass(jsonDataResult) ??
      (this.isGmlTankPayload(jsonDataResult) ? 0 : null);
    const currentD_iclass = this.getActiveDamageClass();

    if (savedD_iclass !== null && currentD_iclass !== null && savedD_iclass !== currentD_iclass) {
      this.openErrorModal("The current assessment does not match the saved assessment. Verify that the selected assessment module matches the saved analysis.", "Assessment Mismatch");
      return;
    }

    const strD_iclass = savedD_iclass ?? this.getActiveDamageClass();

        switch (strD_iclass) {
          case 0: // GML
          this.handleGMLImport(jsonDataResult);
          break;
        case 1: // LML – MFH files contain _mfhLml:true
          if (jsonDataResult._mfhLml === true) {
            Component_MFH.ImportFromJson(jsonDataResult);
            this.openjsontoreadforMFHLml(jsonDataResult);
          } else {
            LTA_module.ImportFromJson(jsonDataResult);
            this.openjsontoreadforLTAtypeA(jsonDataResult);
          }
          break;
        case 2: // LMLPD
          LTAP_module.ImportFromJson(jsonDataResult);
          this.openjsontoreadforLTAPtypeA(jsonDataResult);
          break;
        case 3: // Gouges – MFH files contain _mfhLml:true
          if (jsonDataResult._mfhLml === true) {
            Component_MFH.ImportFromJson(jsonDataResult);
            this.openjsontoreadforMFHLml(jsonDataResult);
          } else {
            GougeModule.ImportFromJson(jsonDataResult);
            this.openjsontoreadforGougestypeA(jsonDataResult);
          }
          break;
        case 4: // Pitting
          Pitting_module.ImportFromJson(jsonDataResult);
          this.openjsontoreadforPittingtypeA(jsonDataResult);
          break;
        case 5: // Blister and HIC
          BlisterHIC_module.ImportFromJson(jsonDataResult);
          this.openjsontoreadforBlisterHICtypeA(jsonDataResult);
          break;
        case 6: // Crack-Like Indications
          Crack_Module.ImportFromJson(jsonDataResult);
          this.openjsontoreadforCrackliketypeA(jsonDataResult);
          let unit = localStorage.getItem('unitType');
          let unitValue = unit ? Number(unit) : 0;
          let divider = unitValue === 0 ? 1000 : 1;
          Crack_Module.sngA_stress = Number(Component_MAWP.sngS_stress / divider);
          this.componentEventService.updateCompMAWPintEquip(jsonDataResult.Component_MAWP.intEquip);
          break;
        case 7:
          Dent_Module.DentImportFromJson(jsonDataResult);
          this.openjsontoreadforDenttypeA(jsonDataResult);
          break;
        case 8: // DentGouge
          Dent_Module.DentGougeImportFromJson(jsonDataResult);
          this.openjsontoreadforDentGougetypeA(jsonDataResult);
          break;
        case 9: // Laminations
          Laminations_module.ImportFromJson(jsonDataResult);
          this.openjsontoreadforLaminationstypeA(jsonDataResult);
          break;
        default:
          break;
      }

     
    const strD_class =
      (jsonDataResult.Component_MAWP && typeof jsonDataResult.Component_MAWP.strD_class !== 'undefined')
        ? jsonDataResult.Component_MAWP.strD_class
        : (jsonDataResult.Component_MAEP && typeof jsonDataResult.Component_MAEP.strD_class !== 'undefined')
          ? jsonDataResult.Component_MAEP.strD_class
          : null;
       if(strD_class == "GML"){
          if(jsonDataResult.GML_module.typedamageval?.toString().toUpperCase() === 'RADIOBUTTON1_DI_ENABLED'){
          this.triggerMAWPUpdateFormControlsEvent();
          }
          else if(jsonDataResult.GML_module.typedamageval?.toString().toUpperCase() === 'RADIOBUTTON2_DI_ENABLED'){
          this.triggerMAEPUpdateFormControlsEvent();
          }
      }
      else {
          this.triggerMAWPUpdateFormControlsEvent();
      }
      
      const strD_iclasscheck =
          (typeof Component_MAWP?.strD_iclass !== 'undefined' && Component_MAWP?.strD_iclass !== null)
            ? Component_MAWP.strD_iclass
            : Component_MAEP.strD_iclass;

        switch (strD_iclasscheck) {
          case 4:
          this.triggerPittingInformationUpdateFormControlsEvent();
          break;
        case 3:
          this.triggerGougesDataUpdateFormControlsEvent();
          this.triggerInspectionDataUpdateFormControlsEvent();
          break;
        case 6:
          this.triggerCrackLikeIndicationse_ComponentInformationUpdateFormControlsEvent();
          this.triggerInspectionDataUpdateFormControlsEvent();
          break;
        case 8:
          this.triggerDentGouge_ComponentInformationUpdateFormControlsEvent();
          this.triggerInspectionDataUpdateFormControlsEvent();
          break;
        default:
          this.triggerInspectionDataUpdateFormControlsEvent();
          break;
      }
    }
  };
  this.componentEventService.setReevalButtonEnabled(true);
  reader.readAsText(file);
  this.fileInput.nativeElement.value = null; // reset the input after import
  this.isLoading = false;
  this.componentEventService.isImporting = false;
}

  exportButtonGrayedOutBasedOnMatSteps() {
    return !(parseInt(localStorage.getItem('calculationStep')) === 0); //need to add below test and then olnly push

  //  (parseInt(localStorage.getItem("TypeAradioselection"))!= 1)||(parseInt(localStorage.getItem("TypeAradioselection"))!= 2)||(parseInt(localStorage.getItem("TypeAradioselection"))!= 3)
  //   ||(parseInt(localStorage.getItem("TypeAradioselection"))!= 4)
  }

  importButtonGrayedOutBasedOnMatSteps() {
     let calculationStep: number = parseInt(localStorage.getItem('calculationStep'));
    // return !(calculationStep >= 1 && calculationStep <= 4);

      return !(calculationStep > 2 && calculationStep <= 5);


     
  }

  private getDamageClass(data: any): number | null {
    const value = [
      data?.strD_iclass,
      data?.GML_module?.strD_iclass,
      data?.Component_MAWP?.strD_iclass,
      data?.Component_MAEP?.strD_iclass,
    ].find((candidate) => candidate !== undefined && candidate !== null && candidate !== "");
    if (value !== undefined) {
      return Number(value);
    }
    return this.isGmlTankPayload(data) ? 0 : null;
  }

  private getActiveDamageClass(): number | null {
    const value = Component_MAWP?.strD_iclass ?? Component_MAEP?.strD_iclass;
    return value === undefined || value === null ? null : Number(value);
  }

  private isGmlTankPayload(data: any): boolean {
    const typeA = data?.typeaData?.TypeARadioSelect ?? data?.GML_module?.typeAradsel;
    const componentType = data?.typeaData?.ComponetType ?? data?.GML_module?.Cmptype;
    const isTank =
      Number(typeA) === 7 ||
      Number(data?.Component_MFH?.intEquip) === 8 ||
      componentType?.toString().toUpperCase() === "TANK";
    return Boolean(data?.GML_module && data?.Component_MFH && isTank);
  }

    importedDataWithErrors(jsonDataResult): boolean {
    // Check if at least one of the components exists and has strD_iclass
    const hasMAWP = jsonDataResult?.Component_MAWP && typeof jsonDataResult.Component_MAWP.strD_iclass !== 'undefined';
    const hasMAEP = jsonDataResult?.Component_MAEP && typeof jsonDataResult.Component_MAEP.strD_iclass !== 'undefined';
    // MFH tank LML/Gouge files carry their state on Component_MFH (plus a slim
    // top-level discriminator) rather than a full Component_MAWP snapshot.
    const isMfhLmlPayload = jsonDataResult?._mfhLml === true && !!jsonDataResult?.Component_MFH;

    if (!hasMAWP && !hasMAEP && !this.isGmlTankPayload(jsonDataResult) && !isMfhLmlPayload) {
      this.openErrorModal("No supported assessment component is present in the data file.");
      return true;
    }

    // If you reach here, at least one is present and valid
    return false;
  }

  private openErrorModal(warningMessage: string, caption: string = "File Read Error"): void {
    this.dialog.open(WarningModalComponent, {
      width: "600px",
      data: {
        warningMessage: [warningMessage],
        caption: caption,
        captionCenter: true,
        cancelButtonShow: false,
      },
    });
  }



  
  openjsontoreadforLTAtypeA(jsonDataResult)
  {
         //shameer -start    
         let radval:number;            
         if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
           {    radval = 1;    }
           else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
           {    radval = 2;  }
           else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
           {    radval = 3;  }
           else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
           {    radval = 4;  }
           else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
           {    radval = 5;  }
                   
            this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
            this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
            // have to keep in storage, so that same can access same content while printing report and to save as json
            localStorage.setItem("TypeAradioselection",radval.toString());  
            
            // Damage radio button
          const damageVal = jsonDataResult.LTA_module.typedamageval?.toString().toUpperCase();
          let damageKey = "";
          if (damageVal === "RADIOBUTTON1_DI_ENABLED".toUpperCase()) {
            damageKey = "radioButton1_DI_enabled";
            LTA_module.intLoadingType = 0;
            Component_MAWP.strRadio = 0;
            Component_MAEP.strRadio = 0;
            this.componentEventService.radioButtonDI = "radioButton1_DI_enabled";
          } else if (damageVal === "RADIOBUTTON2_DI_ENABLED".toUpperCase()) {
            damageKey = "radioButton2_DI_enabled";
            LTA_module.intLoadingType = 1;
            Component_MAWP.strRadio = 1;
            Component_MAEP.strRadio = 1;
            this.componentEventService.radioButtonDI = "radioButton2_DI_enabled";
          }
          this.componentEventService.updateTypeDamageValue(damageKey);
          this.componentEventService.isImporting = true;
            // for tooltip
            let inpt1:number;
            let inpt2:number;
            let TypeofUnit:string;
            let us_si:number;
            let typaresfmjsn;
 
            inpt1 = jsonDataResult.typeaData.Input1_value;
            inpt2 = jsonDataResult.typeaData.Input2_value;
 
            // have to keep in storage, so that same can access same content while printing report and to save as json
            const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
            localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));
 
            TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
            if(TypeofUnit === "US")
            {  us_si = 0;}
            else if(TypeofUnit === "SI")
            {  us_si = 1; }
            this.componentEventService.updatetypeAinput1val(inpt1);
            this.componentEventService.updatetypeAinput2val(inpt2); 
            //for typeof unit
            this.componentEventService.updatetypeAUnitTypeval(us_si);   
 
             this.triggerLTAtypeAupdateradioFormControlsEvent1(); //
                    
                    if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
                      {
                        this.triggerLTA_ApplicabilityCheckboxFormControlUpdateEvent();  //
                        typaresfmjsn = 0              
                      }
                        else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
                      {
                        this.triggerLTA_TYPEApplicabilityCheckboxFormControlUpdateEvent();      //
                        typaresfmjsn = 1;
                      }                    
                      //for typeA res frm jsn
                       this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
                    //shameer -end
  }

  openjsontoreadforLTAPtypeA(jsonDataResult)
  {
   //shameer -start    
   let radval:number;            
   if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
     {    radval = 1;    }
     else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
     {    radval = 2;  }
     else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
     {    radval = 3;  }
     else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
     {    radval = 4;  }
     else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
     {    radval = 5;  }
     else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CylindricalAtmosphericStorageTankShellCourses")
     {    radval = 7;  }
             
      this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
      this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
      // have to keep in storage, so that same can access same content while printing report and to save as json
      localStorage.setItem("TypeAradioselection",radval.toString());     
       // Damage radio button
      const damageVal = jsonDataResult.LTAP_module.typedamageval?.toString().toUpperCase();
      let damageKey = "";
      if (damageVal === "RADIOBUTTON1_DI_ENABLED".toUpperCase()) {
        damageKey = "radioButton1_DI_enabled";
        LTA_module.intLoadingType = 0;
        Component_MAWP.strRadio = 0;
        Component_MAEP.strRadio = 0;
        this.componentEventService.radioButtonDI = "radioButton1_DI_enabled";
      } else if (damageVal === "RADIOBUTTON2_DI_ENABLED".toUpperCase()) {
        damageKey = "radioButton2_DI_enabled";
        LTA_module.intLoadingType = 1;
        Component_MAWP.strRadio = 1;
        Component_MAEP.strRadio = 1;
        this.componentEventService.radioButtonDI = "radioButton2_DI_enabled";
      }
      this.componentEventService.updateTypeDamageValue(damageKey);
      this.componentEventService.isImporting = true;

      if(damageKey.toString().toUpperCase() === "RADIOBUTTON2_DI_ENABLED".toUpperCase()){
      GML_module.isExternalLoading = true;
      }
      // for tooltip
      let inpt1:number;
      let inpt2:number;
      let TypeofUnit:string;
      let us_si:number;
      let typaresfmjsn;

      inpt1 = jsonDataResult.typeaData.Input1_value;
      inpt2 = jsonDataResult.typeaData.Input2_value;

      // have to keep in storage, so that same can access same content while printing report and to save as json
      const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
      localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

      TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
      if(TypeofUnit === "US")
      {  us_si = 0;}
      else if(TypeofUnit === "SI")
      {  us_si = 1; }
      this.componentEventService.updatetypeAinput1val(inpt1);
      this.componentEventService.updatetypeAinput2val(inpt2); 
      //for typeof unit
      this.componentEventService.updatetypeAUnitTypeval(us_si);   

       this.triggerLTAPtypeAupdateradioFormControlsEvent1(); //
              
              if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
                {
                  
                  this.triggerLTAP_ApplicabilityCheckboxFormControlUpdateEvent(); //
                  typaresfmjsn = 0              
                }
                  else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
                {
                  this.triggerLTAP_TYPEApplicabilityCheckboxFormControlUpdateEvent();      //
                  typaresfmjsn = 1;
                }                    
                //for typeA res frm jsn
                 this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
              //shameer -end
  }
  // ── MFH-LML import handler (strictly isolated – does not touch any other module) ──
  openjsontoreadforMFHLml(jsonDataResult: any) {
    const radval = 7; // CylindricalAtmosphericStorageTankShellCourses = MFH mode
    this.componentEventService.updateTypeASelectedValue(radval);
    this.componentEventService.updatetypeAradioselected(radval);
    localStorage.setItem("TypeAradioselection", radval.toString());

    // Damage radio button
    const damageVal = (jsonDataResult.typedamageval || "").toString().toUpperCase();
    let damageKey = "radioButton1_DI_enabled";
    if (damageVal === "RADIOBUTTON2_DI_ENABLED") {
      damageKey = "radioButton2_DI_enabled";
      LTA_module.intLoadingType = 1;
      Component_MAWP.strRadio = 1;
      Component_MAEP.strRadio = 1;
      this.componentEventService.radioButtonDI = "radioButton2_DI_enabled";
    } else {
      LTA_module.intLoadingType = 0;
      Component_MAWP.strRadio = 0;
      Component_MAEP.strRadio = 0;
      this.componentEventService.radioButtonDI = "radioButton1_DI_enabled";
    }
    this.componentEventService.updateTypeDamageValue(damageKey);
    this.componentEventService.isImporting = true;

    const TypeofUnit = (jsonDataResult.typeaData?.TypeofUnit || "US").toString();
    const us_si = TypeofUnit === "SI" ? 1 : 0;
    this.componentEventService.updatetypeAinput1val(0);
    this.componentEventService.updatetypeAinput2val(0);
    this.componentEventService.updatetypeAUnitTypeval(us_si);
    localStorage.setItem("unitType", us_si.toString());

    // Patch the TypeA radio to 7 so local-metal-loss enters MFH mode
    this.triggerLTAtypeAupdateradioFormControlsEvent1();
    // Mark applicability as passed
    this.triggerLTA_ApplicabilityCheckboxFormControlUpdateEvent();
    this.componentEventService.updatetypeAresultjsnval(0);
  }

  openjsontoreadforGougestypeA(jsonDataResult)
  {
 //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString()); 
    
  // Damage radio button
      const damageVal = jsonDataResult.GougeModule.typedamageval?.toString().toUpperCase();
      let damageKey = "";
      if (damageVal === "RADIOBUTTON1_DI_ENABLED".toUpperCase()) {
        damageKey = "radioButton1_DI_enabled";
        LTA_module.intLoadingType = 0;
        Component_MAWP.strRadio = 0;
        Component_MAEP.strRadio = 0;
        this.componentEventService.radioButtonDI = "radioButton1_DI_enabled";
      } else if (damageVal === "RADIOBUTTON2_DI_ENABLED".toUpperCase()) {
        damageKey = "radioButton2_DI_enabled";
        LTA_module.intLoadingType = 1;
        Component_MAWP.strRadio = 1;
        Component_MAEP.strRadio = 1;
        this.componentEventService.radioButtonDI = "radioButton2_DI_enabled";
      }
      this.componentEventService.updateTypeDamageValue(damageKey);
      this.componentEventService.isImporting = true;
       if(damageKey.toString().toUpperCase() === "RADIOBUTTON2_DI_ENABLED".toUpperCase()){
      GML_module.isExternalLoading = true;
      }
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggergougestypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerGouges_ApplicabilityCheckboxFormControlUpdateEvent();  //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerGouges_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforPittingtypeA(jsonDataResult)
  {
    //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggerpittingtypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerPitting_ApplicabilityCheckboxFormControlUpdateEvent();  //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerPitting_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforBlisterHICtypeA(jsonDataResult)
  {
     //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggerblisterhictypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerBlisterAndHIC_ApplicabilityCheckboxAndFormUpdateEvent();  //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerBlisterHIC_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforDenttypeA(jsonDataResult)
  {
    //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggerdenttypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerDents_ApplicabilityCheckboxFormControlUpdateEvent();  //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerDent_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforDentGougetypeA(jsonDataResult)
  {
    //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggerdentgougetypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerDentGouge_ApplicabilityCheckboxFormControlUpdateEvent()   //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerDentGouge_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforLaminationstypeA(jsonDataResult)
  {
    //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggerlaminationstypeAupdateradioFormControlsEvent1();  //
            
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                
                this.triggerLaminationsApplicabilityCheckboxFormControlUpdateEvent();   //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerLaminations_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }

  openjsontoreadforCrackliketypeA(jsonDataResult)
  {
     //shameer -start    
 let radval:number;            
 if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "VerticalVessel")
   {    radval = 1;    }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HorizonalVessel")
   {    radval = 2;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "CarbonandLowAllySteelPiping")
   {    radval = 3;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "HighAlloyNonFerrousSteelPiping")
   {    radval = 4;  }
   else if(jsonDataResult.typeaData.TypeARadioSelect.toString() === "SphericalComponents")
   {    radval = 5;  }
           
    this.componentEventService.updateTypeASelectedValue(radval); //older- to update dropdown cmptype
    this.componentEventService.updatetypeAradioselected(radval); //newer- to get typeA radio selection value
    // have to keep in storage, so that same can access same content while printing report and to save as json
    localStorage.setItem("TypeAradioselection",radval.toString());           
    // for tooltip
    let inpt1:number;
    let inpt2:number;
    let TypeofUnit:string;
    let us_si:number;
    let typaresfmjsn;

    inpt1 = jsonDataResult.typeaData.Input1_value;
    inpt2 = jsonDataResult.typeaData.Input2_value;

    // have to keep in storage, so that same can access same content while printing report and to save as json
    const verticalinputsdata = { inputvalue1 :inpt1 , inputvalue2: inpt2 };
    localStorage.setItem('verticalinputs', JSON.stringify(verticalinputsdata));

    TypeofUnit = jsonDataResult.typeaData.TypeofUnit.toString();
    if(TypeofUnit === "US")
    {  us_si = 0;}
    else if(TypeofUnit === "SI")
    {  us_si = 1; }
    this.componentEventService.updatetypeAinput1val(inpt1);
    this.componentEventService.updatetypeAinput2val(inpt2); 
    //for typeof unit
    this.componentEventService.updatetypeAUnitTypeval(us_si);   

         this.triggercrackliketypeAupdateradioFormControlsEvent1();  //
                     
            if(jsonDataResult.typeaData.typeAresult.toString() === "PASS" )
              {
                this.triggerCrackLikeIndications_ApplicabilityCheckboxAndFormUpdateEvent();   //
                typaresfmjsn = 0              
              }
                else if (jsonDataResult.typeaData.typeAresult.toString() === "FAIL")
              {
                this.triggerCracklike_TYPEAApplicabilityCheckboxFormControlUpdateEvent()      //
                typaresfmjsn = 1;
              }                    
              //for typeA res frm jsn
               this.componentEventService.updatetypeAresultjsnval(typaresfmjsn);  
            //shameer -end
  }
}